import { useEffect, useId, useRef, useState } from 'react'

import { LoadingSpinner } from 'src/components/atoms/LoadingSpinner'

import { env } from 'src/env/client.mjs'
import { logError } from 'src/utils/errors'

const HUBSPOT_SCRIPT_SRC = 'https://js.hsforms.net/forms/v2.js'

type HubspotFormEmbedProps = {
  formId: string
  onFormSubmit?: () => void
}

export const HubspotFormEmbed = ({
  formId,
  onFormSubmit
}: HubspotFormEmbedProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const targetId = `hubspotForm-${useId().replace(/:/g, '')}`

  const onFormSubmitRef = useRef(onFormSubmit)
  onFormSubmitRef.current = onFormSubmit

  useEffect(() => {
    const createForm = () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          portalId: env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID,
          region: env.NEXT_PUBLIC_HUBSPOT_PORTAL_REGION,
          formId,
          target: `#${targetId}`,
          onFormSubmit: () => onFormSubmitRef.current?.()
        })
      }
      setIsLoading(false)
    }

    // @ts-ignore
    if (window.hbspt) {
      createForm()
      return
    }

    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${HUBSPOT_SCRIPT_SRC}"]`
    )
    const script = existing ?? document.createElement('script')

    const onLoad = () => createForm()
    const onError = (error: Event | string) => {
      logError(error)
      setIsLoading(false)
    }

    script.addEventListener('load', onLoad)
    script.addEventListener('error', onError)

    if (!existing) {
      script.src = HUBSPOT_SCRIPT_SRC
      document.body.appendChild(script)
    }

    return () => {
      script.removeEventListener('load', onLoad)
      script.removeEventListener('error', onError)
    }
  }, [formId, targetId])

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div id={targetId} />
    </>
  )
}

export default HubspotFormEmbed
